var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"name":"outlink-popup"}},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"close-icon",attrs:{"src":require("../../assets/close_icn.png")},on:{"click":_vm.close}})]),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.link,"width":"100%"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3c3d30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/OutLinkPopup.vue
// module id = null
// module chunks = 